export const HEARTBEAT_INTERVAL = 5000;
export const SET_THEME = "SET_THEME";
export const SET_SETTINGS = "SET_SETTINGS";
export const CHANGE_BITRATE = "CHANGE_BITRATE";
export const CHANGE_VOLUME = "CHANGE_VOLUME";
export const REQUEST_HEARTBEAT = "REQUEST_HEARTBEAT";
export const RECEIVE_HEARTBEAT = "RECEIVE_HEARTBEAT";
export const REQUEST_STREAMS = "REQUEST_STREAMS";
export const RECEIVE_STREAMS = "RECEIVE_STREAMS";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";

// User Profile types
export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";
export const FETCH_PROFILE_FAILED = "FETCH_PROFILE_FAILED";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILED = "UPDATE_PROFILE_FAILED";
export const TOGGLE_PROFILE_WINDOW = "TOGGLE_PROFILE_WINDOW";

//User Reducers
export const SET_LOGGEDIN_USER = "SET_LOGGEDIN_USER";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_KEYCLOAK_DATA = "SET_KEYCLOAK_DATA";
export const SET_MEMBERSHIP_DATA_V2 = "SET_MEMBERSHIP_DATA_V2";
export const UPDATE_MODIFY_MODE = "UPDATE_MODIFY_MODE";
